export default "__VITE_ASSET__d6effe0c__"